import { render } from "./ActivitiesListingMassDelete.vue?vue&type=template&id=35fcce5f"
import script from "./ActivitiesListingMassDelete.vue?vue&type=script&lang=js"
export * from "./ActivitiesListingMassDelete.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__